import React from 'react';
import fieldParams from '../../const/fieldParams';
import '../../assets/styles/privacy-terms.sass';

const PrivacyTerms = ({ fieldKey }) => {
  const { urlList } = fieldParams[fieldKey] || {};

  const onClickHandler = e => {
    const { href, target } = e.target || {};
    e.preventDefault();
    window.open(href, target ? target : '_self');
  };
  return (
    <div className="privacy-terms">
      {Object.keys(urlList).map((type, i) => {
        return (
          <a
            key={i}
            href={urlList[type]}
            target="_blank"
            rel="noopener noreferrer"
            className="privacy-terms-link"
            onClick={onClickHandler}
          >
            {type}
          </a>
        );
      })}
    </div>
  );
};

export default PrivacyTerms;
